import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "react-bootstrap-icons";
import { SocialLinks } from "./SocialLinks";

const MENU = [
  { href: "#about", label: "About" },
  { href: "#services", label: "What I do" },
  { href: "#work", label: "Projects" },
  { href: "#contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuButtonRef = useRef(null);
  const closeButtonRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!open) return;
    const menuButton = menuButtonRef.current;
    document.documentElement.classList.add("menu-open");
    closeButtonRef.current?.focus();
    const onKey = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.documentElement.classList.remove("menu-open");
      window.removeEventListener("keydown", onKey);
      menuButton?.focus();
    };
  }, [open]);

  // Close first, then scroll, so the page isn't scroll-locked when we jump.
  const goTo = (event, href) => {
    event.preventDefault();
    setOpen(false);
    requestAnimationFrame(() => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" }));
  };

  return (
    <>
      <header className={`site-header${scrolled ? " is-scrolled" : ""}`}>
        <a href="#top" className="wordmark">Khushi Tulsiyan</a>
        <div className="header-actions">
          <a href="#contact" className="header-cta">Let's talk</a>
          <button
            ref={menuButtonRef}
            type="button"
            className="menu-button"
            aria-expanded={open}
            aria-controls="site-menu"
            onClick={() => setOpen(true)}
          >
            Menu
          </button>
        </div>
      </header>

      <div
        id="site-menu"
        className={`menu-overlay${open ? " is-open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="Menu"
        inert={!open}
      >
        <div className="menu-top">
          <span className="wordmark">Khushi Tulsiyan</span>
          <button ref={closeButtonRef} type="button" className="menu-button" onClick={() => setOpen(false)}>
            Close
          </button>
        </div>
        <nav aria-label="Main">
          <ul className="menu-links">
            {MENU.map(({ href, label }, index) => (
              <li key={href} style={{ "--i": index }}>
                <a href={href} onClick={(event) => goTo(event, href)}>
                  {label}
                  <ArrowRight className="menu-arrow" aria-hidden="true" />
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <SocialLinks className="menu-social" />
      </div>
    </>
  );
};
